import { render, staticRenderFns } from "./ReturnGoodsModal.vue?vue&type=template&id=7ef18ed4&scoped=true&"
import script from "./ReturnGoodsModal.vue?vue&type=script&lang=js&"
export * from "./ReturnGoodsModal.vue?vue&type=script&lang=js&"
import style0 from "./ReturnGoodsModal.vue?vue&type=style&index=0&id=7ef18ed4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef18ed4",
  null
  
)

export default component.exports